<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div :class="bodyClassName">
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fa fa-fw fa-chart-network"></i> {{ _('Sales Channels') }}</h3>
        </div>
      </div>
      <editor-tabs id="tabNavi" v-show="!hasFocus" :tabs="tabList" :selected="selectedTab" :id-prefix="tabIdPrefix" v-on:select="tab" />
      <div class="tab-content">
        <transition-group name="fade">
          <div v-bind="tabPanel('johkusaleschannels')" class="tab-pane active" id="johkusaleschannels" v-if="isTabActive('johkusaleschannels')" key="johkusaleschannels">
            <div class="row">
              <div :class="colClass + ' leftcol'">
                <h3>{{ _('Johku Sales Channels') }}</h3>
                <button style="margin-bottom: 20px" type="button" class="addjohkusaleschannel btn btn-success" id="addJohkuSalesChannelButton" v-on:click="requestShopDialog"><i class="fa fa-fw fa-envelope-o"></i> {{ _('Request access to a Johku-based sales channel') }}</button>
                <div class="panel-group flex-panel" id="channelaccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-info johkusaleschannel" v-for="saleschannel in johkuSalesChannels">
                    <div class="panel-heading" role="tab" :id="'channelHeading' + saleschannel.id">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapse' + saleschannel.id)" :aria-controls="'channelCollapse' + saleschannel.id" v-on:click="togglePanel('channelCollapse' + saleschannel.id)">
                          <span class="title-text">{{ saleschannel.title ? saleschannel.title : saleschannel.channel }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'channelCollapse' + saleschannel.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeading' + saleschannel.id" v-if="isPanelOpen('channelCollapse' + saleschannel.id)">
                        <div class="panel-body">
                          <p>{{ _('Commission') }}: {{ saleschannel.commission }} %</p>
                          <button type="button" class="btn btn-danger removeChannel" v-on:click="removeSalesChannelDialog(saleschannel)"><i class="fa fa-fw fa-trash"></i> {{ _('Remove sales channel') }}</button>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <h3 v-if="johkuSalesChannelIncomingOffers && johkuSalesChannelIncomingOffers.length" id="incomingOffersTitle">{{ _('Notifications and Offers from Sales Channels') }}</h3>
                <div v-if="johkuSalesChannelIncomingOffers && johkuSalesChannelIncomingOffers.length" class="panel-group flex-panel" id="incomingofferaccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-info johkusaleschannel" v-for="saleschannel in johkuSalesChannelIncomingOffers">
                    <div class="panel-heading" role="tab" :id="'channelHeadingIncomingOffer' + saleschannel.id">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseIncomingOffer' + saleschannel.id)" :aria-controls="'channelCollapseIncomingOffer' + saleschannel.id" v-on:click="togglePanel('channelCollapseIncomingOffer' + saleschannel.id)">
                          <span class="title-text">{{ saleschannel.title }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'channelCollapseIncomingOffer' + saleschannel.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeadingIncomingOffer' + saleschannel.id" v-if="isPanelOpen('channelCollapseIncomingOffer' + saleschannel.id)">
                        <div class="panel-body">
                          <div class="form-group">
                            <p v-if="saleschannel.offer?.message"><i>{{ saleschannel.offer.message }}</i></p>
                            <p v-if="saleschannel.terms"><b>{{ _('Terms') }}</b></p>
                            <template v-html="saleschannel.terms"></template>
                            <label>{{ _('Commission') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" :value="saleschannel.offer?.commission" disabled="disabled">
                              <div class="input-group-addon">%</div>
                            </div>
                          </div>
                          <button type="button" class="btn btn-success acceptChannelOffer" v-on:click="acceptChannelOffer(saleschannel)"><i class="fa fa-fw fa-check"></i> {{ _('Enable') }}</button>
                          <button type="button" class="btn btn-danger rejectChannelOffer" v-on:click="rejectChannelOffer(saleschannel)"><i class="fa fa-fw fa-ban"></i> {{ _('Reject') }}</button>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <h3 v-if="johkuSalesChannelSentRequests && johkuSalesChannelSentRequests.length" id="sentRequestsTitle">{{ _('Sent Requests to Sales Channels') }}</h3>
                <div v-if="johkuSalesChannelSentRequests && johkuSalesChannelSentRequests.length" class="panel-group flex-panel" id="incomingofferaccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-info johkusaleschannel" v-for="saleschannel in johkuSalesChannelSentRequests">
                    <div class="panel-heading" role="tab" :id="'channelHeadingSentRequest' + saleschannel.id">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseSentRequest' + saleschannel.id)" :aria-controls="'channelCollapseSentRequest' + saleschannel.id" v-on:click="togglePanel('channelCollapseSentRequest' + saleschannel.id)">
                          <span class="title-text">{{ saleschannel.title ? saleschannel.title : saleschannel.channel }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'channelCollapseSentRequest' + saleschannel.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeadingSentRequest' + saleschannel.id" v-if="isPanelOpen('channelCollapseSentRequest' + saleschannel.id)">
                        <div class="panel-body">
                          <div class="form-group">
                            <p v-if="saleschannel.message"><i>{{ saleschannel.message }}</i></p>
                          </div>
                          <p v-if="saleschannel.status">{{ _('Status') }}: {{ getStatus(saleschannel.status) }}</p>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 rightcol" v-if="false">
                <h3>{{ _('Private Sales Channels') }}</h3>
                <table class="table table-striped saleschannelrows">
                  <thead>
                    <tr>
                      <th>{{ _('Name') }}</th>
                      <th>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody class="resourcerows" id="salesChannels">
                    <tr v-for="saleschannel in privateSalesChannels">
                      <td>{{ saleschannel.name }}</td>
                      <td><a href="javascript:;" class="pull-right" v-on:click="removePrivateSalesChannel(saleschannel)"><i class="fa fa-fw fa-close"></i></a></td>
                    </tr>
                  </tbody>
                </table>
                <div class="form-inline">
                  <button type="button" class="addsaleschannel btn btn-success" id="addSalesChannelButton" v-on:click="selectPrivateSalesChannel"><i class="fa fa-fw fa-plus"></i> {{ _('Add private sales channel') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('othersaleschannels')" class="tab-pane active" id="othersaleschannels" v-if="isTabActive('othersaleschannels')" key="othersaleschannels">
            <div class="row">
              <div :class="colClass + ' leftcol'">
                <h3>{{ _('Other Sales Channels') }}</h3>
                <div class="panel-group flex-panel" id="channelaccordion" role="tablist" aria-multiselectable="true">
                  <div :class="channelPanelClass('channex')" v-if="isFeatureEnabled('channex')">
                    <div class="panel-heading" role="tab" id="channelHeadingZero">
                      <h4 class="panel-title">
                        <input type="checkbox" v-model="settings.channel_channex" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_channex)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseZero')" :aria-controls="'channelCollapseZero'" v-on:click="togglePanel('channelCollapseZero')">
                          <span class="title-text">{{ _('External Sales Channels') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition" v-if="parseInt(settings.channel_channex) && settings.channex_group">
                      <div id="channelCollapseZero" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingZero" v-if="isPanelOpen('channelCollapseZero')">
                        <div class="panel-body">
                          <div class="alert alert-danger" style="margin-top: 10px" v-if="!isBillingInformationOk">
                            <p>{{ _('In order to link products to external sales channel properties you must first provide your billing details. You can do this in the Company Profile section of Johku Settings.') }}</p>
                            <button style="margin-top: 10px" class="btn btn-danger" type="button" v-on:click="openCompanyProfile"><i class="fa fa-fw fa-building-o"></i> {{ _('Open Company Profile') }}</button>
                          </div>
                          <div class="form-inline pull-right">
                            <button v-if="channexProperties && channexProperties.length" type="button" class="btn btn-info" v-on:click="showChannexBookings()"><i class="fa fa-fw fa-bed"></i> {{ _('Bookings') }}</button>
                            <button type="button" class="btn btn-success" v-on:click="modifyChannexPropertyDialog()" :disabled="!isBillingInformationOk"><i class="fa fa-fw fa-plus"></i> {{ _('building|Add Property') }}</button>
                          </div>
                          <h4>{{ _('building|Properties') }}</h4>
                          <table class="table table-striped channexproperties">
                            <thead>
                              <tr>
                                <th>{{ _('Name') }}</th>
                                <th>{{ _('Type') }}</th>
                                <th></th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="property in channexProperties" v-on:click="modifyChannexPropertyDialog(property)" style="cursor: pointer">
                                <td>{{ property.title }}</td>
                                <td>{{ getChannexPropertyCategoryTitle(property.property_category) }}<template v-if="property.property_category !== 'hotel'"> ({{ _('Number of rooms') }}: {{ getChannexNumberOfRooms(property) }})</template></td>
                                <td><button class="btn btn-info btn-xs" style="padding-top: 0px; padding-bottom: 0px" v-on:click.stop="showChannexBookings(property)"><i class="fa fa-fw fa-bed"></i> {{ _('Bookings') }}</button></td>
                                <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeChannexPropertyDialog(property)"><i class="fa fa-fw fa-close"></i></a></td>
                              </tr>
                              <tr v-if="!channexProperties || !channexProperties.length">
                                <td colspan="4"><i>{{ _('No properties have been added.') }}</i></td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="form-inline pull-right">
                            <Dropdown buttonClass="btn-success" :buttonDisabled="!isBillingInformationOk" v-if="channexProperties && channexProperties.length">
                              <template #trigger>
                                <i class="fa fa-fw fa-plus"></i> {{ _('Add Room Type') }} &nbsp;<span class="caret"></span>
                              </template>
                              <li v-for="property in channexProperties"><a href="javascript:;" v-on:click="createChannexRoomTypeForProperty(property)">{{ property.title }} ({{ getChannexPropertyCategoryTitle(property.property_category) }})</a></li>
                            </Dropdown>
                          </div>
                          <h4>{{ _('Room Types') }}</h4>
                          <table class="table table-striped channexroomtypes">
                            <thead>
                              <tr>
                                <th>{{ _('Name') }}</th>
                                <th>{{ _('Product') }}</th>
                                <th></th>
                                <th>{{ _('building|Property') }}</th>
                                <th>{{ _('Rooms') }}</th>
                                <th>{{ _('Adults') }}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="roomType in channexRoomTypes" v-on:click="modifyChannexRoomTypeDialog(roomType)" style="cursor: pointer">
                                <td>{{ roomType.title }}</td>
                                <td><template v-if="roomType.product">{{ roomType.product.name }}</template><span v-else style="color: red">{{ _('Missing room type link!') }}</span></td>
                                <td>
                                  <button v-if="roomType.product" v-on:click.stop="unlinkChannexRoomTypeDialog(roomType)" class="btn btn-xs btn-warning" style="padding-top: 0px; padding-bottom: 0px"><i class="fa fa-fw fa-link-slash"></i> {{ _('Unlink') }}</button>
                                  <button v-else v-on:click.stop="linkChannexRoomTypeDialog(roomType)" class="btn btn-xs btn-primary" style="padding-top: 0px; padding-bottom: 0px"><i class="fa fa-fw fa-link"></i> {{ _('Link') }}</button>
                                </td>
                                <td>{{ getChannexPropertyTitle(roomType.property_id) }}</td>
                                <td>{{ roomType.count_of_rooms }}</td>
                                <td>{{ roomType.occ_adults }}</td>
                                <td><a href="javascript:;" class="pull-right" v-on:click.stop="removeChannexRoomTypeDialog(roomType)"><i class="fa fa-fw fa-close"></i></a></td>
                              </tr>
                              <tr v-if="!channexRoomTypes || !channexRoomTypes.length">
                                <td colspan="7"><i>{{ _('No room types have been added.') }}</i></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </transition>
                    <transition v-else v-on="slideTransition">
                      <div id="channelCollapseZero" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingZero" v-if="isPanelOpen('channelCollapseZero')">
                        <div class="panel-body">
                          <button type="button" class="btn btn-success" v-on:click="enableChannex"><i class="fa fa-fw fa-magic"></i> {{ _('Enable External Sales Channels') }}</button>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('gofinland')">
                    <div class="panel-heading" role="tab" id="channelHeadingOne">
                      <h4 class="panel-title">
                        <input type="checkbox" v-model="settings.channel_gofinland" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_gofinland)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseOne')" aria-controls="channelCollapseOne" v-on:click="togglePanel('channelCollapseOne')">
                          <span class="title-text">{{ _('Nettimökki') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseOne" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingOne" v-if="isPanelOpen('channelCollapseOne')">
                        <div class="panel-body">
                          <p>{{ _('Nettimökki is the leading marketplace for rental cottages in Finland, with a comprehensive selection of both privately and business owned rentals.') }}</p>
                          <p><strong><a id="showGofinlandTerms" href="javascript:;" v-on:click="showGofinlandTerms">{{ _('By enabling the Nettimökki Sales Channel you accept these terms and conditions.') }}</a></strong></p>
                          <p>{{ _('A support user account for Nettimökki will also be automatically created to your shop.') }}</p>
                          <p v-if="parseInt(origSettings.channel_gofinland)"><i>{{ _('If you want to deactivate Nettimökki, please contact customer service.') }}</i></p>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('hotellinx')">
                    <div class="panel-heading" role="tab" id="channelHeadingTwo">
                      <h4 class="panel-title">
                        <input type="checkbox" class="pull-right" v-model="settings.channel_hotellinx" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_hotellinx)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseTwo')" aria-controls="channelCollapseTwo" v-on:click="togglePanel('channelCollapseTwo')">
                          <span class="title-text">{{ _('Hotellinx') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseTwo" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingTwo" v-if="isPanelOpen('channelCollapseTwo')">
                        <div class="panel-body">
                          <div class="form-group">
                            <label for="hotellinx_url">{{ _('API URL') }}</label>
                            <input type="text" class="form-control" id="hotellinxApiUrl" :placeholder="_('Enter your Hotellinx server\'s API URL')" name="hotellinx_url" v-model="settings.hotellinx_url" />
                          </div>
                          <div class="form-group">
                            <label for="hotellinx_username">{{ _('API username') }}</label>
                            <input type="text" class="form-control" id="hotellinxApiUsername" :placeholder="_('Enter your Hotellinx server\'s API username')" name="hotellinx_username" v-model="settings.hotellinx_username" />
                          </div>
                          <div class="form-group">
                            <label for="hotellinx_password">{{ _('API password') }}</label>
                            <input type="text" class="form-control" id="hotellinxApiPassword" :placeholder="_('Enter your Hotellinx server\'s API password')" name="hotellinx_password" v-model="settings.hotellinx_password" />
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('myallocator')">
                    <div class="panel-heading" role="tab" id="channelHeadingThree">
                      <h4 class="panel-title">
                        <input type="checkbox" class="pull-right" v-model="settings.channel_myallocator" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_myallocator)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseThree')" aria-controls="channelCollapseThree" v-on:click="togglePanel('channelCollapseThree')">
                          <span class="title-text">{{ _('MyAllocator') }}</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseThree" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingThree" v-if="isPanelOpen('channelCollapseThree')">
                        <div class="panel-body">
                          <div class="form-group">
                            <label for="myallocator_userid">{{ _('User ID') }}</label>
                            <input type="text" class="form-control" id="myallocatorUserId" :placeholder="_('Enter your MyAllocator User ID')" name="myallocator_userid" v-model="settings.myallocator_userid" />
                          </div>
                          <template v-if="settings.myallocator_token">
                            <p>{{ _('Your MyAllocator account has been connected to Johku. For security reasons we haven\'t saved your password, instead we will be using the token below for authentication.') }}</p>
                            <p>{{ _('To discontinue using MyAllocator in Johku or to re-enter your credentials, simply clear the value and save settings.') }}</p>
                            <div class="form-group">
                              <label for="myallocator_token">{{ _('Token') }}</label>
                              <input type="text" class="form-control" id="myallocatorToken" name="myallocator_token" v-model="settings.myallocator_token" />
                            </div>
                          </template>
                          <div v-else class="form-group">
                            <label for="myallocator_password">{{ _('Password') }}</label>
                            <input type="text" class="form-control" id="myallocatorPassword" :placeholder="_('Enter your MyAllocator Password')" name="myallocator_password" v-model="settings.myallocator_password" />
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('retkipaikka')">
                    <div class="panel-heading" role="tab" id="channelHeadingFour">
                      <h4 class="panel-title">
                        <input type="checkbox" class="pull-right" v-model="settings.channel_retkipaikka" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_retkipaikka)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseFour')" aria-controls="channelCollapseFour" v-on:click="togglePanel('channelCollapseFour')">
                        <span class="title-text">Retkipaikka.fi</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseFour" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingFour" v-if="isPanelOpen('channelCollapseFour')">
                        <div class="panel-body">
                          <p>{{ _('Retkipaikka is a community, a blog and a social periodical media.') }}</p>
                          <p><strong><a id="showRetkipaikkaTerms" href="javascript:;" v-on:click="showRetkipaikkaTerms">{{ _('By enabling the Retkipaikka Sales Channel you accept these terms and conditions.') }}</a></strong></p>
                          <p v-if="parseInt(origSettings.channel_retkipaikka)"><i>{{ _('If you want to deactivate Retkipaikka, please contact customer service.') }}</i></p>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('bokun')">
                    <div class="panel-heading" role="tab" id="channelHeadingFive">
                      <h4 class="panel-title">
                        <input type="checkbox" class="pull-right" v-model="settings.channel_bokun" true-value="1" false-value="0" :disabled="!!parseInt(origSettings.channel_bokun)" />
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseFive')" aria-controls="channelCollapseFive" v-on:click="togglePanel('channelCollapseFive')">
                        <span class="title-text">Bókun</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseFive" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingFive" v-if="isPanelOpen('channelCollapseFive')">
                        <div class="panel-body">
                          <p>{{ _('The all-in-one platform built to help your tour & activity business stay organized and get more bookings online.') }}</p>
                          <template v-if="settings.bokun_accesskey || settings.bokun_secretkey">
                            <div class="form-group">
                              <label for="bokun_accesskey">{{ _('Access key') }}</label>
                              <input type="text" class="form-control" id="bokunAccessKey" name="bokun_accesskey" v-model="settings.bokun_accesskey" />
                            </div>
                            <div class="form-group">
                              <label for="bokun_secretkey">{{ _('Secret key') }}</label>
                              <input type="text" class="form-control" id="bokunSecretKey" name="bokun_secretkey" v-model="settings.bokun_secretkey" />
                            </div>
                            <div class="form-group" v-if="isFeatureEnabled('activitypricing')">
                              <div class="checkbox">
                                <label>
                                  <input type="checkbox" id="bokunPush" v-model="settings.bokun_push" true-value="1" false-value="0" />
                                  {{ _('Update linked Bókun experiences') }}
                                </label>
                              </div>
                              <p><i>{{ _('Rates, ticket categories and start times of products with a Bókun experience id are sent to Bókun when the product is saved and every night. This changes the experiences in Bókun.') }}</i></p>
                            </div>
                          </template>
                          <p>{{ _('Bookings made through the Bókun integration are processed as invoices in Johku, which will be subject to the same commission as other invoices.') }}</p>
                        </div>
                      </div>
                    </transition>
                  </div>
                  <div :class="channelPanelClass('gyg')" v-if="isGygFeatureEnabled">
                    <div class="panel-heading" role="tab" id="channelHeadingGyg">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('channelCollapseGyg')" aria-controls="channelCollapseGyg" v-on:click="togglePanel('channelCollapseGyg')">
                        <span class="title-text">GetYourGuide</span>
                        <span class="indicator"></span>
                      </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div id="channelCollapseGyg" class="panel-collapse" role="tabpanel" aria-labelledby="channelHeadingGyg" v-if="isPanelOpen('channelCollapseGyg')">
                        <div class="panel-body">
                          <div class="form-group">
                            <div class="checkbox">
                              <label>
                                <input type="checkbox" id="channelGyg" v-model="settings.channel_gyg" true-value="1" false-value="0" />
                                {{ _('Sell through GetYourGuide') }}
                              </label>
                            </div>
                          </div>
                          <p>{{ _('Products are connected in GetYourGuide\'s Supplier Portal by pasting the product ID shown on the Other Sales Channels tab of each product. No GetYourGuide credentials are needed in Johku.') }}</p>
                          <p v-if="gygRegistration.status === 'sent'"><i class="fa fa-fw fa-check"></i> {{ _('Registration sent %s; GetYourGuide confirms by email.').replace('%s', formatGygRegistrationDate(gygRegistration.ts)) }}</p>
                          <div class="form-group" v-else>
                            <p>{{ _('If you don\'t have a GetYourGuide supplier account yet, you can register as a supplier from here.') }}</p>
                            <button type="button" class="btn btn-success" id="gygRegisterButton" v-on:click="registerGyg" :disabled="gygRegistering"><i class="fa fa-fw fa-envelope-o"></i> {{ _('Register with GetYourGuide') }}</button>
                            <p class="help-block">{{ gygTerms.before }}<a href="https://supplier.getyourguide.com/terms-conditions" target="_blank" rel="noopener">{{ gygTerms.terms }}</a>{{ gygTerms.middle }}<a href="https://www.getyourguide.com/c/privacy-policy" target="_blank" rel="noopener">{{ gygTerms.privacy }}</a>{{ gygTerms.after }}</p>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('channelprices')" class="tab-pane active" id="channelprices" v-if="isTabActive('channelprices') && isFeatureEnabled('activitypricing')" key="channelprices">
            <div class="row">
              <div :class="colClass + ' leftcol'">
                <h3>{{ _('Channel Prices') }}</h3>
                <channel-price-rules />
              </div>
              <div class="col-sm-6 rightcol" v-if="!isDetailsColumnOpen">
                <p>{{ _('Channel price rules adjust the prices of bookings made by users who have access to the sales channel, for example net prices for travel agents.') }}</p>
                <p>{{ _('The general rule applies to all products. You can override it for a single product in the product\'s settings.') }}</p>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('shopsusingyoursaleschannel')" class="tab-pane active" id="shopsusingyoursaleschannel" v-if="isTabActive('shopsusingyoursaleschannel')" key="shopsusingyoursaleschannel">
            <div class="row">
              <div :class="colClass + ' leftcol'">
                <h3 v-if="johkuSalesChannelIncomingRequests && johkuSalesChannelIncomingRequests.length" id="incomingRequestsTitle">{{ _('Requests to Access Your Sales Channel') }}</h3>
                <div v-if="johkuSalesChannelIncomingRequests && johkuSalesChannelIncomingRequests.length" class="panel-group flex-panel" id="incomingaccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-info johkusaleschannelincomingrequest" v-for="(saleschannel, index) in johkuSalesChannelUnprocessedIncomingRequests">
                    <div :id="'channelHeadingIncomingrequest' + saleschannel.id + '-' + index" class="panel-heading" role="tab">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('#channelCollapseIncomingrequest' + saleschannel.id + '-' + index)" :aria-controls="'channelCollapseIncomingrequest' + saleschannel.id + '-' + index" v-on:click="togglePanel('#channelCollapseIncomingrequest' + saleschannel.id + '-' + index)">
                          <span class="title-text">{{ saleschannel.requestingshop.companyname }} ({{ saleschannel.requestingshop.shopid }})</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'channelCollapseIncomingrequest' + saleschannel.id + '-' + index" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeadingIncomingrequest' + saleschannel.id + '-' + index" v-if="isPanelOpen('#channelCollapseIncomingrequest' + saleschannel.id + '-' + index)">
                        <div class="panel-body">
                          <p v-if="saleschannel.status">{{ _('Status') }}: {{ getStatus(saleschannel.status) }}</p>
                          <div class="well" v-if="parseInt(saleschannel.status) === CHANNEL_APPROVED">
                            <template v-for="offer in johkuSalesChannelSentOffers.filter(o => o.shopid === saleschannel.requestingshop.shopid)">
                              <h4 style="margin-top: 0px">{{ _('Invitation sent') }}</h4>
                              <label>{{ _('Commission') }}:</label> {{ offer.commission }} %<br />
                              <label>{{ _('Status') }}:</label> {{ getStatus(offer.status) }}
                            </template>
                          </div>
                          <div class="form-group" v-if="saleschannel.requestingshop && saleschannel.requestingshop.companyemail">
                            <label>{{ _('Email') }}</label><br />
                            <a :href="'mailto:' + saleschannel.requestingshop.companyemail">{{ saleschannel.requestingshop.companyemail}}</a>
                          </div>
                          <div class="form-group" v-if="saleschannel.requestingshop && saleschannel.requestingshop.companyphone">
                            <label for="ignore_phone">{{ _('Phone') }}</label><br />
                            {{ saleschannel.requestingshop.companyphone }}
                          </div>
                          <button v-if="showSaleschannelResendButton(saleschannel)" v-on:click="toggleSaleschannelResend(saleschannel)" type="button" class="btn btn-default"><i class="fa fa-retweet fa-fw"></i> {{ _('Resend') }}</button>
                          <template v-else>
                            <div class="form-group">
                              <label>{{ _('Commission') }}</label>
                              <div class="input-group">
                                <input type="number" data-android-inputmode="decimal" class="form-control" v-model="saleschannel.defaultcommission">
                                <div class="input-group-addon">%</div>
                              </div>
                            </div>
                            <button v-if="!isAccepted(saleschannel)" type="button" class="btn btn-success approveChannelRequest" v-on:click="approveChannelRequest(saleschannel.requestingshop.shopid, saleschannel.defaultcommission, saleschannel.status)"><i class="fa fa-fw fa-check"></i> {{ _('Approve') }}</button>
                            <button v-if="!isRejected(saleschannel)" type="button" class="btn btn-danger rejectChannelRequest" v-on:click="rejectChannelRequest(saleschannel.requestingshop.shopid, saleschannel.defaultcommission, saleschannel.status)"><i class="fa fa-fw fa-ban"></i> {{ _('Reject') }}</button>
                          </template>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
                <div id="incomingRequestsRejected" v-if="johkuSalesChannelRejectedIncomingRequests.length">
                  <a data-toggle="collapse" href="#incomingrejectedcollapse" v-on:click="toggleRejectedRequests">{{ _('Rejected requests') }}</a> 
                  <div class="collapse" id="incomingrejectedcollapse" v-if="showRejectedRequests">
                    <div class="panel-group flex-panel" id="incomingrejectedaccordion" role="tablist" aria-multiselectable="true">
                      <div class="panel panel-info johkusaleschannelincomingrequest" v-for="(saleschannel, index) in johkuSalesChannelRejectedIncomingRequests">
                        <div :id="'channelHeadingIncomingrequest' + saleschannel.id + '-r' + index" class="panel-heading" role="tab">
                          <h4 class="panel-title">
                            <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('#channelCollapseIncomingrequest' + saleschannel.id + '-r' + index)" :aria-controls="'channelCollapseIncomingrequest' + saleschannel.id + '-r' + index" v-on:click="togglePanel('#channelCollapseIncomingrequest' + saleschannel.id + '-r' + index)">
                              <span class="title-text">{{ saleschannel.requestingshop.companyname }} ({{ saleschannel.requestingshop.shopid }})</span>
                              <span class="indicator"></span>
                            </a>
                          </h4>
                        </div>
                        <transition v-on="slideTransition">
                          <div :id="'channelCollapseIncomingrequest' + saleschannel.id + '-r' + index" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeadingIncomingrequest' + saleschannel.id + '-r' + index" v-if="isPanelOpen('#channelCollapseIncomingrequest' + saleschannel.id + '-r' + index)">
                            <div class="panel-body">
                              <p v-if="saleschannel.status">{{ _('Status') }}: {{ getStatus(saleschannel.status) }}</p>
                              <div class="form-group" v-if="saleschannel.requestingshop && saleschannel.requestingshop.companyemail">
                                <label>{{ _('Email') }}</label><br />
                                <a :href="'mailto:' + saleschannel.requestingshop.companyemail">{{ saleschannel.requestingshop.companyemail}}</a>
                              </div>
                              <div class="form-group" v-if="saleschannel.requestingshop && saleschannel.requestingshop.companyphone">
                                <label for="ignore_phone">{{ _('Phone') }}</label><br />
                                {{ saleschannel.requestingshop.companyphone }}
                              </div>
                              <div class="form-group">
                                <label>{{ _('Commission') }}</label>
                                <div class="input-group">
                                  <input type="number" data-android-inputmode="decimal" class="form-control" v-model="saleschannel.defaultcommission">
                                  <div class="input-group-addon">%</div>
                                </div>
                              </div>
                              <button v-if="!isAccepted(saleschannel)" type="button" class="btn btn-success approveChannelRequest" v-on:click="approveChannelRequest(saleschannel.requestingshop.shopid, saleschannel.defaultcommission, saleschannel.status)"><i class="fa fa-fw fa-check"></i> {{ _('Approve') }}</button>
                              <button v-if="!isRejected(saleschannel)" type="button" class="btn btn-danger rejectChannelRequest" v-on:click="rejectChannelRequest(saleschannel.requestingshop.shopid, saleschannel.defaultcommission, saleschannel.status)"><i class="fa fa-fw fa-ban"></i> {{ _('Reject') }}</button>
                            </div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
                <h3>{{ _('Shops Using Your Sales Channel') }}</h3>
                <div class="panel-group flex-panel" id="shopsaccordion" role="tablist" aria-multiselectable="true">
                  <div class="panel panel-info johkushop" v-for="shop in johkuSalesChannelShops">
                    <div class="panel-heading" role="tab" :id="'shopHeading' + shop.id">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#shopaccordion" href="javascript:;" :aria-expanded="isPanelOpen('#shopCollapse' + shop.id)" :aria-controls="'shopCollapse' + shop.id" v-on:click="togglePanel('#shopCollapse' + shop.id)">
                          <span class="title-text">{{ shop.title }} ({{ shop.shopid }})</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'shopCollapse' + shop.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'shopHeading' + shop.id" v-if="isPanelOpen('#shopCollapse' + shop.id)">
                        <div class="panel-body">
                          <p>{{ _('Commission') }}: {{ parseFloat(shop.commission) }} %</p> 
                          <p>{{ _('Status') }}: {{ (parseInt(shop.enabled) ? _('Enabled') : _('Disabled')) }}</p>
                          <div class="flex-row">
                            <button type="button" class="btn btn-success modifyShop" v-on:click="modifyShopDialog(shop)"><i class="fa fa-fw fa-pencil"></i> {{ _('Modify commission') }}</button>  
                            <button type="button" class="btn btn-danger removeShop" v-on:click="removeShopDialog(shop)"><i class="fa fa-fw fa-trash"></i> {{ _('Remove shop') }}</button>
                          </div>
                        </div> 
                      </div>
                    </transition>
                  </div>
                </div>
                <div class="form-inline">
                  <button type="button" class="btn btn-success" id="inviteShopButton" v-on:click="inviteShopDialog"><i class="fa fa-fw fa-envelope-o"></i> {{ _('Invite a Johku merchant to your Sales Channel') }}</button>
                </div>
                <h3 v-if="johkuSalesChannelSentOffers && johkuSalesChannelSentOffers.length">{{ _('Sent invites') }}</h3>
                <div class="panel-group flex-panel" id="offeraccordion" role="tablist" aria-multiselectable="true" v-if="johkuSalesChannelSentOffers">
                  <div class="panel panel-info johkusaleschannel" v-for="saleschannel in johkuSalesChannelSentOffers">
                    <div class="panel-heading" role="tab" :id="'channelHeadingOffer' + saleschannel.id">
                      <h4 class="panel-title">
                        <a class="collapsed" data-toggle="collapse" data-parent="#channelaccordion" href="javascript:;" :aria-expanded="isPanelOpen('#channelCollapseOffer' + saleschannel.id)" :aria-controls="'channelCollapseOffer' + saleschannel.id" v-on:click="togglePanel('#channelCollapseOffer' + saleschannel.id)">
                          <span class="title-text">{{ saleschannel.title }} ({{ saleschannel.shopid }})</span>
                          <span class="indicator"></span>
                        </a>
                      </h4>
                    </div>
                    <transition v-on="slideTransition">
                      <div :id="'channelCollapseOffer' + saleschannel.id" class="panel-collapse" role="tabpanel" :aria-labelledby="'channelHeadingOffer' + saleschannel.id" v-if="isPanelOpen('#channelCollapseOffer' + saleschannel.id)">
                        <div class="panel-body">
                          <div class="form-group">
                            <p v-if="saleschannel.message"><i>{{ saleschannel.message }}</i></p>
                            <label>{{ _('Commission') }}</label>
                            <div class="input-group">
                              <input type="text" class="form-control" :value="saleschannel.commission" disabled="disabled">
                              <div class="input-group-addon">%</div>
                            </div>
                            <p v-if="saleschannel.status">{{ _('Status') }}: {{ getStatus(saleschannel.status) }}</p>
                          </div>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-bind="tabPanel('mysaleschannel')" class="tab-pane active" id="mysaleschannel" v-if="isTabActive('mysaleschannel')" key="mysaleschannel">
            <div class="row">
              <div :class="colClass + ' leftcol'">
                <h3>{{ _('My Sales Channel') }}</h3>
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" id="toggleSaleschannel" name="mysaleschannel_enabled" v-model="saleschannel.enabled" true-value="1" false-value="0" /> {{ _('Publish this sales channel to other Johku merchants') }}
                    </label>
                  </div>
                </div>
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" id="toggleOnboarding" name="mysaleschannel_onboarding" v-model="saleschannel.onboarding" true-value="1" false-value="0" /> {{ _('Enable onboarding of other Johku merchants on your Storefront') }}
                    </label>
                  </div>
                </div>
                <div class="form-group" data-search="data-service">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" id="toggleOnboarding" name="mysaleschannel_dataservice" v-model="settings.dataservice" true-value="1" false-value="0" /> {{ _('Allow saving the shop identifier to Johku Data Service for identification') }}<!-- Salli kaupan tunnisteen tallennus Johkun datapalveluun tunnistamista varten -->
                    </label>
                  </div>
                </div>
                <div class="form-group languageversioned">
                  <label for="mysaleschannel_title">{{ _('Sales channel name') }}</label>
                  <input type="text" class="form-control" id="saleschannelTitle" :placeholder="_('Enter the sales channel name')" v-model="saleschannel.title" />
                </div>
                <div class="form-group">
                  <label for="mysaleschannel_url">{{ _('URL') }}</label>
                  <input type="text" class="form-control" id="saleschannelUrl" :placeholder="_('Enter the sales channel\'s web address')" v-model="saleschannel.url" />
                </div>
                <div class="form-group languageversioned">
                  <label for="mysaleschannel_description">{{ _('Short description') }}</label>
                  <textarea class="form-control" id="saleschannelDescription" :placeholder="_('Enter the sales channel description')" v-model="saleschannel.description"></textarea>
                </div>
                <div class="form-group languageversioned">
                  <label for="mysaleschannel_longdescription">{{ _('Long description') }}</label>
                  <editor v-model="saleschannel.longdescription" />
                </div>
                <div class="form-group languageversioned">
                  <label for="mysaleschannel_terms">{{ _('Terms') }}</label>
                  <editor v-model="saleschannel.terms" />
                </div>
                <div class="form-group languageversioned" data-search="customer-profile">
                  <label for="mysaleschannel_terms">{{ _('Customer profile') }}</label>
                  <editor v-model="saleschannel.profile" />
                </div>
                <div class="form-group languageversioned">
                  <h4>{{ _('Saleschannel tags') }}</h4>
                </div>
                <div class="form-group" data-search="saleschannel-tags">
                  <!-- <input class="form-control wide textField" id="newTag" type="text" value="" /> -->
                  <v-select :options="[]" v-model="saleschannelTagToAdd" v-on:option:selected="addSaleschannelTag" :taggable="true" label="title" :keys="['title']" :placeholder="_('Type to search or add tags')">
                    <template v-slot:no-options="{ searching }">
                      <template v-if="searching">
                        {{ _('No results found.') }}
                      </template>
                      <template v-else>{{ _('Type to search or add tags') }}</template>
                    </template>
                  </v-select>
                </div>
                <div class="form-group">
                  <div class="flex-row" id="tagsList">
                    <span v-for="tag in saleschannelTags" class="btn btn-info" v-on:click="removeTag(tag)"><i class="fa fa-fw fa-close"></i> {{ getTagTitle(tag) }}</span>
                  </div>
                </div>
                <div class="form-group">
                  <p>{{ _('Saleschannel tags can be used by your submerchants to group their products according to your set of tags.') }}</p>
                </div>
                <div class="form-group">
                  <label for="mysaleschannel_defaultcommission">{{ _('Default commission') }}</label>
                  <div class="input-group">
                    <input type="number" data-android-inputmode="decimal" class="form-control" id="saleschannelDefaultCommission" :placeholder="_('Enter the default commission of the sales channel')" v-model="saleschannel.defaultcommission" />
                    <div class="input-group-addon">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <nav class="save-bar">
      <div class="row">
        <div class="col-md-12">
          <div class="pull-right">
            <button class="btn btn-default" v-on:click="close" v-if="showCloseButton"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
            <button class="btn btn-success" v-on:click="save" :disabled="!isSaveButtonEnabled"><i :class="'fa fa-fw fa-' + saveButtonIcon"></i> {{ saveButtonText }}</button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios'
import { DateTime } from 'luxon'
import { ChannelPriceRules, GofinlandTerms, RetkipaikkaTerms, DraggableMultiSelector, Editor } from '#components'
import channexhelpers from '~/lib/channexhelpers'
import components from '~/lib/components'
import modals from '~/lib/modals'
import currencies from '~/lib/currencies'
import pricetierrules from '~/lib/pricetierrules'
import producttypes from '~/lib/producttypes'
import settingseditors from '~/lib/settingseditors'
import settingshelpers from '~/lib/settingshelpers'
import slidetransition from '~/lib/slidetransition'

export default {
  data () {
    const _ = useNuxtApp().$translate
    return {
      origSettings: {},
      defaultSaleschannel: {
        title: '',
        description: '',
        longdescription: '',
        terms: '',
        profile: '',
        url: '-',
        image: '',
        email: '',
        phone: '',
        defaultcommission: '0',
        autoapprove: '0',
        enabled: '0',
        published: '0',
        onboarding: '0'
      },
      activeTab: 'johkusaleschannels',
      privateSalesChannels: [],
      saleschannelTagToAdd: '',
      johkuSalesChannels: [],
      johkuSalesChannelShops: [],
      johkuSalesChannelIncomingOffers: [],
      johkuSalesChannelIncomingRequests: [],
      johkuSalesChannelSentOffers: [],
      johkuSalesChannelSentRequests: [],
      showRejectedRequests: false,
      selectedChannexProperty: null,
      channexProperties: [],
      channexRoomTypes: [],
      installedChannexApplications: [],
      allProducts: [],
      roomTypeFields: [
        {
          title: _('Number of rooms'),
          type: 'number',
          name: 'count_of_rooms',
          defaultValue: 1
        },
        {
          title: _('Number of adults'),
          type: 'number',
          name: 'occ_adults',
          defaultValue: 1
        },
        {
          title: _('Number of children'),
          type: 'number',
          name: 'occ_children',
          defaultValue: 0
        },
        {
          title: _('Number of infants'),
          type: 'number',
          name: 'occ_infants',
          defaultValue: 0
        },
        {
          title: _('Default occupancy'),
          type: 'number',
          name: 'default_occupancy',
          defaultValue: 1
        }
      ],
      resendToggles: {},
      gygRegistration: {
        status: '',
        ts: null
      },
      gygRegistering: false
    }
  },
  props: ['focus'],
  mixins: [channexhelpers, components, currencies, modals, pricetierrules, producttypes, settingseditors, settingshelpers, slidetransition],
  computed: {
    tabList () {
      return this.editorTabs([
        { id: 'johkusaleschannels', label: this._('Johku Sales Channels') },
        { id: 'othersaleschannels', label: this._('Other Sales Channels') },
        { id: 'channelprices', label: this._('Channel Prices'), hidden: !this.isFeatureEnabled('activitypricing') },
        { id: 'shopsusingyoursaleschannel', label: this._('Shops Using Your Sales Channel') },
        { id: 'mysaleschannel', label: this._('My Sales Channel') }
      ])
    },
    isGygFeatureEnabled () {
      return this.isFeatureEnabled('gyg') && this.isFeatureEnabled('activitypricing')
    },
    // GetYourGuide requires this sentence under the registration button, with links to its terms and privacy policy
    gygTerms () {
      const english = {
        sentence: 'By clicking on the button above you agree to the Supplier Terms and Conditions and the Privacy Policy from GetYourGuide.',
        terms: 'Supplier Terms and Conditions',
        privacy: 'Privacy Policy'
      }
      const translated = {
        sentence: this._('By clicking on the button above you agree to the Supplier Terms and Conditions and the Privacy Policy from GetYourGuide.'),
        terms: this._('Supplier Terms and Conditions'),
        privacy: this._('Privacy Policy')
      }
      const split = (t) => {
        const i = t.sentence.indexOf(t.terms)
        const j = i === -1 ? -1 : t.sentence.indexOf(t.privacy, i + t.terms.length)
        if (j === -1) {
          return null
        }
        return {
          before: t.sentence.substring(0, i),
          terms: t.terms,
          middle: t.sentence.substring(i + t.terms.length, j),
          privacy: t.privacy,
          after: t.sentence.substring(j + t.privacy.length)
        }
      }
      return split(translated) || split(english)
    },
    colClass () {
      return this.isDetailsColumnOpen ? 'col-sm-12' : 'col-sm-6'
    },
    isDetailsColumnOpen () {
      return !!(this.columns && this.columns.find(c => c.identifier === 'details'))
    },
    isBillingInformationOk() {
      return this.settings && this.settings.companyname && this.settings.companyid && (this.settings.billingemail || (this.settings.companyevoice && this.settings.companyevoiceint))
    },
    hasFocus () {
      return !!this.focus
    },
    showCloseButton () {
      if (this.isModal || (this.componentTrail && this.componentTrail.length > 1)) {
        return true
      }
      return false
    },
    saleschannel: {
      get () {
        return this.settings && this.settings.saleschannel ? this.settings.saleschannel : this.defaultSaleschannel
      },
      set (newValue) {
        console.log('Set sales channel')
        this.settings.saleschannel = newValue
      }
    },
    saleschannelTags: {
      get () {
        if (!this.saleschannel || !this.saleschannel.sharedTag) {
          return []
        }
        return this.saleschannel.sharedTag.filter(t => t.title.match(new RegExp('^' + this.version)))
      }
    },
    johkuSalesChannelUnprocessedIncomingRequests () {
      return this.johkuSalesChannelIncomingRequests.filter(r => parseInt(r.status) !== this.CHANNEL_REJECTED)
    },
    johkuSalesChannelRejectedIncomingRequests () {
      return this.johkuSalesChannelIncomingRequests.filter(r => parseInt(r.status) === this.CHANNEL_REJECTED)
    }
  },
  methods: {
    showChannexBookings (property) {
      this.EventBus.$emit('showDetailsColumn', {
        shopId: this.shopId,
        component: 'ChannexBookingsList',
        title: this._('Bookings'),
        width: 6,
        data: {
          property: property ? property : null
        }
      })
    },
    showSaleschannelResendButton(saleschannel) {
      if (saleschannel && parseInt(saleschannel.status) === this.CHANNEL_APPROVED && !this.resendToggles[saleschannel.id]) {
        return true
      }
      return false
    },
    toggleSaleschannelResend(saleschannel) {
      this.resendToggles[saleschannel.id] = !this.resendToggles[saleschannel.id]
    },
    openCompanyProfile() {
      this.EventBus.$emit('showComponent', {
        shopId: this.shopId,
        component: 'CompanyProfile',
        title: this._('Company profile'),
        initData: {
          activateTab: 'billing'
        }
      })
    },
    async enableChannex () {
      this.settings.channel_channex = '1'
      try {
        await this.save()
      } catch(e) {
        return
      }
      const settings = await this.loadVersionedSettings()
      this.origSettings = Object.assign({}, settings)
      this.localSettings = Object.assign({}, settings)
      this.defaultSaleschannel.shopid = this.shopId
      this.storeState()
      if (parseInt(settings.channel_channex) && settings.channex_group) {
        this.loadChannexProperties()
        this.loadChannexRoomTypes()
        /*
        if (parseInt(settings.channex_messaging) && this.isFeatureEnabled('channexmessaging')) {
          this.loadChannexApplications()
        }
        */
      }
    },
    isRejected (saleschannel) {
      return parseInt(saleschannel.status) === this.CHANNEL_REJECTED
    },
    isAccepted (saleschannel) {
      return parseInt(saleschannel.status) === this.CHANNEL_ACCEPTED
    },
    showGofinlandTerms () {
      this.showModal('gofinlandterms', GofinlandTerms, {
        props: {},
        events: {},
        handlers: {},
        width: 800
      })
    },
    showRetkipaikkaTerms () {
      this.showModal('retkipaikkaterms', RetkipaikkaTerms, {
        props: {},
        events: {},
        handlers: {},
        width: 800
      })
    },
    addSaleschannelTag(tag) {
      this.addTag(tag, 'saleschannel')
    },
    addTag(tag, type) {
      if (!tag) {
        return
      }
      const data = {
        id: null,
        title: this.version + ':::' + tag
      }
      this.saleschannel.sharedTag.push(data)
      nextTick(() => {
        this.saleschannelTagToAdd = ''
      })
    },
    removeTag(tag) {
      this.saleschannel.sharedTag = this.saleschannel.sharedTag.filter(t => t.title !== tag.title)
    },
    async loadPrivateSalesChannels () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/settings/1/saleschannels.json?apikey=' + this.apiKey + this.versionStr)
      } catch(e) {
        this.showError(this._('Error loading sales channels! Please try again.'))
        return
      }
      this.privateSalesChannels = response.data
    },
    loadProducts () {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products.json?iSortingCols=1&iSortCol_0=2&sSortDir_0=asc&sSearch_3=1-anyaccommodation&simple=true&apikey=' + this.apiKey)
        } catch (e) {
          reject()
          return
        }
        this.allProducts = response.data
        resolve(this.allProducts)
      })
    },
    loadAllJohkuSalesChannels () {
      this.loadSalesChannelShops()
      this.loadJohkuSalesChannels()
      this.loadJohkuSalesChannelSentOffers()
      this.loadJohkuSalesChannelSentRequests()
      this.loadJohkuSalesChannelIncomingOffers()
      this.loadJohkuSalesChannelIncomingRequests()
    },
    async loadSalesChannelShops() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?shops=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading shops using your sales channel! Please try again.'));
        return
      }
      this.johkuSalesChannelShops = response.data
    },
    async loadJohkuSalesChannels() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading linked Johku-based sales channels! Please try again.'));
        return
      }
      this.johkuSalesChannels = response.data
    },
    async loadJohkuSalesChannelSentOffers() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?sentoffers=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading linked Johku-based sales channels! Please try again.'));
        return
      }
      this.johkuSalesChannelSentOffers = response.data
    },
    async loadJohkuSalesChannelSentRequests() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?sentrequests=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading linked Johku-based sales channels! Please try again.'));
        return
      }
      this.johkuSalesChannelSentRequests = response.data
    },
    async loadJohkuSalesChannelIncomingOffers() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?incomingoffers=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading linked Johku-based sales channels! Please try again.'));
        return
      }
      this.johkuSalesChannelIncomingOffers = response.data
    },
    async loadJohkuSalesChannelIncomingRequests() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/johkusaleschannels.json?incomingrequests=true&apikey=' + this.apiKey)
      } catch(e) {
        this.showError(this._('Error loading linked Johku-based sales channels! Please try again.'));
        return
      }
      this.johkuSalesChannelIncomingRequests = response.data
    },
    async removeSalesChannel (saleschannel) {
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/johkusaleschannels/' + saleschannel.id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        this.showError(_('Error removing sales channel!'))
        return
      }
      this.loadJohkuSalesChannels()
    },
    selectPrivateSalesChannel () {
      // @todo
    },
    removePrivateSalesChannel (saleschannel) {
      this.privateSalesChannels = this.privateSalesChannels.filter(s => s.id !== saleschannel.id)
    },
    removeSalesChannelDialog (saleschannel) {
      this.showDialog({
        title: this._('Are you sure you want to remove this sales channel?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Remove sales channel'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.removeSalesChannel(saleschannel)
            }
          }
        ]
      })
    },
    toggleRejectedRequests () {
      this.showRejectedRequests = !this.showRejectedRequests
    },
    inviteShopDialog () {
      return this.modifyShopDialog({}, this._('Invite a Johku merchant to your Sales Channel'))
    },
    modifyShopDialog (shop, title) {
      this.showDialog({
        title: title ? title : this._('Notify the shop of a commission change'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Send'),
            class: 'success',
            icon: 'envelope-o',
            requiredFields: ['shopId', 'commission'],
            handler: (data) => {
              this.inviteShop(shop, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Shop ID'),
            type: 'text',
            name: 'shopId',
            placeholder: this._('Enter the identifier of the Johku Store'),
            defaultValue: shop.shopid
          },
          {
            title: this._('Commission'),
            type: 'number',
            name: 'commission',
            placeholder: this._('Enter the commission percentage of the Johku Store'),
            defaultValue: shop.commission
          },
          {
            title: this._('Message'),
            type: 'textarea',
            name: 'message',
            placeholder: this._('Enter an optional message')
          }
        ]
      })
    },
    async inviteShop (shop, data) {
      let response
      data.action = 'offer'
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Invitation sent'))
      } catch(e) {
        this.showError(e, this._('Error sending invitation!'))
        return
      }
      this.loadSalesChannelShops()
      this.loadJohkuSalesChannelSentOffers()
    },
    requestShopDialog () {
      let shop = {}
      this.showDialog({
        title: this._('Request access to Johku merchant Sales Channel'),
        width: 800,
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Send'),
            class: 'success',
            icon: 'envelope-o',
            requiredFields: ['shopId'],
            handler: (data) => {
              this.requestShop(shop, data)
            }
          }
        ],
        fields: [
          {
            title: this._('Shop ID'),
            type: 'text',
            name: 'shopId',
            placeholder: this._('Enter the identifier of the Johku Store'),
            defaultValue: shop.shopid
          },
          {
            title: this._('Message'),
            type: 'textarea',
            name: 'message',
            placeholder: this._('Enter an optional message')
          }
        ]
      })
    },
    async requestShop (shop, data) {
      let response
      data.action = 'request'
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Request sent'))
      } catch (e) {
        this.showError(e, this._('Error sending request!'))
      }
      this.loadSalesChannelShops()
      this.loadJohkuSalesChannelSentRequests()
    },
    removeShopDialog (shop) {
      this.showDialog({
        title: this._('Are you sure you want to remove this shop from your sales channel?'),
        width: 800,
        buttons: [
          {
            title: this._('Cancel'),
            icon: 'ban',
            handler: () => {}
          },
          {
            title: this._('Remove shop'),
            class: 'danger',
            icon: 'trash',
            handler: () => {
              this.removeShop(shop.shopid)
            }
          }
        ]
      })
    },
    async removeShop (shopId) {
      const data = {
        action: 'removeshop',
        shopId: shopId
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Shop removed'))
      } catch(e) {
        this.showError(e, this._('Error removing shop!'))
        return
      }
      this.loadSalesChannelShops()
    },
    checkResend (message) {
      return new Promise((resolve, reject) => {
        this.showDialog({
          title: message,
          buttons: [
            {
              title: this._('Cancel'),
              icon: 'ban',
              handler: reject
            },
            {
              title: this._('Continue anyway'),
              icon: 'check',
              handler: resolve
            }, 
          ],
          clickToClose: false
        })
      })
    },
    async approveChannelRequest (shopId, commission, currStatus) {
      currStatus = parseInt(currStatus)
      if (currStatus && currStatus !== this.CHANNEL_UNPROCESSED) {
        try {
          await this.checkResend(this._('You have already processed this request. Are you sure you want to continue?'))
        } catch(e) {
          return
        }
      }
      const data = {
        action: 'approve',
        commission: commission,
        shopId: shopId
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Channel request approved'))
      } catch(e) {
        this.showError(e, this._('Error approving request!'))
        return
      }
      this.resendToggles = {}
      this.loadJohkuSalesChannelIncomingRequests()
      this.loadJohkuSalesChannelSentOffers()
    },
    async rejectChannelRequest (shopId, commission, currStatus) {
      currStatus = parseInt(currStatus)
      if (currStatus && currStatus !== this.CHANNEL_UNPROCESSED) {
        try {
          await this.checkResend(this._('You have already processed this request. Are you sure you want to continue?'))
        } catch(e) {
          return
        }
      }
      const data = {
        action: 'reject',
        commission: commission,
        shopId: shopId
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Channel request rejected'))
      } catch(e) {
        this.showError(e, this._('Error rejecting request!'))
        return
      }
      this.resendToggles = {}
      this.loadJohkuSalesChannelIncomingRequests()
      this.loadJohkuSalesChannelSentOffers()
    },
    async cancelChannelRequest (saleschannel) {
      const data = {
        channelId: saleschannel.id
      }
      let response
      try {
        response = await axios.delete(this.baseDomain + this.shopId + '/johkusaleschannels/' + saleschannel.id+ '.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Channel request cancelled'))
      } catch(e) {
        this.showError(e, this._('Error cancelling request!'))
        return
      }
      this.loadJohkuSalesChannelSentRequests()
    },
    async acceptChannelOffer (saleschannel) {
      const data = {
        action: 'acceptoffer',
        channelId: saleschannel.id
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Channel offer accepted'))
      } catch(e) {
        this.showError(e, this._('Error approving request!'))
        return
      }
      this.loadJohkuSalesChannels()
      this.loadJohkuSalesChannelSentRequests()
      this.loadJohkuSalesChannelIncomingOffers()
      this.loadJohkuSalesChannelIncomingRequests()
    },
    async rejectChannelOffer (saleschannel) {
      const data = {
        action: 'rejectoffer',
        channelId: saleschannel.id
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
        this.showNotification(this._('Channel offer rejected'))
      } catch(e) {
        this.showError(e, this._('Error rejecting request!'))
        return
      }
      this.loadJohkuSalesChannelSentRequests()
      this.loadJohkuSalesChannelIncomingOffers()
      this.loadJohkuSalesChannelIncomingRequests()
    },
    async dismissChannelOffer (shopId) {
      const data = {
        action: 'dismissoffer',
        shopId: shopId
      }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/johkusaleschannels.json?apikey=' + this.apiKey, data)
      } catch(e) {
        this.showError(e, this._('Error rejecting request!'))
        return
      }
      this.loadJohkuSalesChannelSentOffers()
    },
    getTagTitle(tag) {
      if (!tag || !tag.title) {
        return ''
      }
      const parts = tag.title.split(':::')
      return parts.pop()
    },
    getSaveData () {
      const data = settingseditors.methods.getSaveData.call(this)
      const saleschannelFields = ['defaultcommission', 'description', 'enabled', 'longdescription', 'onboarding', 'profile', 'terms', 'title', 'url']
      saleschannelFields.forEach(k => {
        data['mysaleschannel_' + k] = this.saleschannel[k]
      })
      data.tags = this.saleschannel && this.saleschannel.sharedTag ? this.saleschannel.sharedTag.map(t => t.title).join(';') : ''
      data.ownCommission = this.commissions
      data.ownDeliverymethod = this.currDeliveryMethods
      data.ownSaleschannel = this.privateSalesChannels
      data.locale = this.settingsLocale
      data.version = this.version
      data.versions = this.versions
      data.storefrontversions = this.storefrontversions
      return data
    },
    async save () {
      return new Promise(async (resolve, reject) => {
        this.saving = true
        const data = this.getSaveData()
        const gygSwitchedOn = this.isGygFeatureEnabled && !!parseInt(data.channel_gyg) && !parseInt(this.origSettings.channel_gyg)
        if (!this.isGygFeatureEnabled) {
          delete data.channel_gyg
        }
        let response
        try {
          response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, data)
        } catch (e) {
          this.saving = false
          resolve()
          return this.showError(e)
        }
        this.saving = false
        this.saved = true
        this.storeState()
        setTimeout(() => { this.saved = false }, 1000)
        this.showNotification(this._('Changes saved successfully!'))
        this.$emit('save', this.settings)
        if (gygSwitchedOn) {
          this.suggestGygCategories()
        }
        this.close()
        resolve(response)
      })
    },
    // Fills in the empty traveller categories of the price tiers when GetYourGuide is switched on
    async suggestGygCategories () {
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/gyg.json?apikey=' + this.apiKey, { action: 'suggestcategories' })
      } catch (e) {
        this.showError(e)
        return
      }
      const changed = response.data && response.data.changed ? response.data.changed : []
      if (changed.length) {
        const list = changed.map(t => t.name + ': ' + this.gygCategoryLabel(t.category)).join(', ')
        this.showNotification(this._('GetYourGuide traveller categories were set for these price tiers: %s. You can change them in the price tier settings.').replace('%s', list))
      }
    },
    async registerGyg () {
      this.gygRegistering = true
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/gyg.json?apikey=' + this.apiKey, { action: 'register' })
      } catch (e) {
        this.gygRegistering = false
        this.showError(e)
        return
      }
      this.gygRegistering = false
      this.gygRegistration = {
        status: response.data && response.data.status ? response.data.status : 'sent',
        ts: DateTime.now().toUnixInteger()
      }
      this.showNotification(this._('Registration sent'))
    },
    formatGygRegistrationDate (ts) {
      if (!parseInt(ts)) {
        return ''
      }
      return DateTime.fromSeconds(Number(ts), { zone: this.timezone }).toFormat(this.dateFormat)
    },
    channelPanelClass (index) {
      return 'panel panel-' + (this.isChannelEnabled(index) ? 'info' : 'default')
    },
    isChannelEnabled (index) {
      return this.settings && !!parseInt(this.settings['channel_' + index])
    },
    getStatus (s) {
      const _ = this._
      switch(parseInt(s, 10)) {
        case this.CHANNEL_UNPROCESSED:
          return _('Not processed');
        case this.CHANNEL_APPROVED:
          return _('Approved');
        case this.CHANNEL_REJECTED:
          return _('Rejected');
        case this.CHANNEL_ACCEPTED:
          return _('Accepted');
      }
    }
  },
  components: {
    ChannelPriceRules,
    DraggableMultiSelector,
    Editor,
    RetkipaikkaTerms
  },
  async mounted () {
    const settings = await this.loadVersionedSettings()
    this.origSettings = Object.assign({}, settings)
    this.localSettings = Object.assign({}, settings)
    this.defaultSaleschannel.shopid = this.shopId
    this.storeState()
    this.gygRegistration = {
      status: settings.gyg_registration_status || '',
      ts: settings.gyg_registration_ts || null
    }
    this.loadPrivateSalesChannels()
    this.loadAllJohkuSalesChannels()
    if (parseInt(settings.channel_channex) && settings.channex_group) {
      await this.loadChannexProperties()
      this.loadChannexRoomTypes()
      if (this.component && this.component.initData && this.component.initData.activateProperty) {
        this.modifyChannexPropertyDialog(this.component.initData.activateProperty)
      }
      /*
      if (parseInt(settings.channex_messaging) && this.isFeatureEnabled('channexmessaging')) {
        this.loadChannexApplications()
      }
      */
    }
  }
}
</script>

<style scoped>
.panel-collapse {
  overflow-y: hidden;
}
</style>